module.exports = __webpack_public_path__ + "img/corporate-social-responsibility-1.4451dd9c.png";